/* Return Coverage cart add-on toggle.
   Server-rendered inside the cart drawer body (which is fully re-rendered
   on every cart mutation); the custom element re-upgrades after each swap. */
if (!customElements.get('return-coverage-toggle')) {
  customElements.define(
    'return-coverage-toggle',
    class ReturnCoverageToggle extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.rc-row__switch-input');
        if (this.input) this.input.addEventListener('change', this.onToggle.bind(this));
      }

      async onToggle() {
        if (this.classList.contains('is-loading')) return;
        this.classList.add('is-loading');
        if (this.input) this.input.disabled = true;

        try {
          if (this.dataset.inCart === 'true') {
            const items = document.querySelector('cart-drawer-items');
            if (items) await items.updateQuantity(this.dataset.line, 0);
          } else {
            const cartDrawer = document.querySelector('cart-drawer');
            const sections =
              cartDrawer && cartDrawer.getSectionsToRender
                ? cartDrawer.getSectionsToRender().map((s) => s.section)
                : ['cart-drawer'];
            const res = await fetch(routes.cart_add_url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({
                items: [{ id: Number(this.dataset.variantId), quantity: 1 }],
                sections: sections,
                sections_url: window.location.pathname,
              }),
            });
            const data = await res.json();
            if (!data.status && cartDrawer && cartDrawer.renderContents) {
              cartDrawer.renderContents(data, false);
            }
          }
        } catch (e) {
          console.error('Return Coverage toggle failed', e);
          if (this.input) this.input.checked = this.dataset.inCart === 'true';
        }

        /* On success the whole row re-renders server-side; this cleanup
           only matters on failure. */
        this.classList.remove('is-loading');
        if (this.input) this.input.disabled = false;
      }
    }
  );
}
